import { useQuery, useMutation } from "@apollo/client";
import {
  getPropertyInfoById,
  getPropertyInfoByIdVariables,
  updateProperty as updatePropertyMutationType,
  updatePropertyVariables,
} from "types/gql-types";
import { GET_PROPERTY_INFO, UPDATE_PROPERTY_DETAILS } from "../queries";

export type PropertyFormData = {
  name: string;
  email: string;
  phone: string;
  phoneExt: string;
  address: {
    address1: string;
    address2: string;
    city: string;
    state: string;
    zip: string;
  };
}

export const usePropertyInfo = (propertyId: string) => {
  const { data, loading, error } = useQuery<
  getPropertyInfoById,
  getPropertyInfoByIdVariables
  >(GET_PROPERTY_INFO, {
    variables: { id: propertyId },
  });

  const [updatePropertyMutation] = useMutation<updatePropertyMutationType, updatePropertyVariables>(
    UPDATE_PROPERTY_DETAILS,
  );

  // eslint-disable-next-line require-await
  const updateProperty = async (values: PropertyFormData) =>
    updatePropertyMutation({ variables: { id: propertyId, data: values } });

  return {
    property: data?.property,
    loading,
    error,
    updateProperty,
  };
};
